import { snakeCase } from 'lodash-es'

export type EnvKey =
  | 'area'
  | 'release'
  | 'feOss'
  | 'beOss'
  | 'privatization'
  | 'airwallexEnv'
  | 'env'
  | 'updateMessageJson'
  | 'shence'
  | 'wsMessageCenter'
  | 'apiMessageCenter'
  | 'apiBase'

export const getEnv = (env: EnvKey) => {
  const envStr = import.meta.server
    ? process.env[`NUXT_PUBLIC_${snakeCase(env).toUpperCase()}`]
    : (window.__NUXT__ as any).config.public[env]
  if (envStr === 'true') {
    return true
  }

  if (envStr === 'false') {
    return false
  }

  return envStr
}

export const getArea = (): Area => {
  let area: Area = 'CN'
  if (import.meta.server) {
    area = process.env.NUXT_PUBLIC_AREA as Area
  }
  if (import.meta.client) {
    area = (window.__NUXT__ as any).config.public.area as Area
  }

  return area || 'CN'
}

export const getVersion = () => {
  const release = import.meta.server
    ? process.env.NUXT_PUBLIC_RELEASE
    : (window.__NUXT__ as any).config.public.release
}
